/**
 * Nome compartilhado do view-transition da imagem do produto: o mesmo nome no
 * card da listagem (/cursos) e no hero de /cursos/info/[id] faz o navegador
 * morfar uma imagem na outra. O id é o mesmo usado na rota de info
 * (`external_id ?? reference`).
 */
export const productImageTransitionName = (productId: string): string =>
  `product-image-${productId}`
